var swm = swm || {};
swm.frontend = swm.frontend || {};

(function ($, root) {
    root.intro = (function() {

        function init() {
            var $intro = document.getElementsByClassName('swm-ui-promotion-intro')[0],
                src = $intro.getAttribute('data-image'),
                $imagewrap = document.getElementsByClassName('swm-ui-image-wrap')[0],
                $img,
                $ele;

                if (!src) {
                    document.getElementsByTagName('body')[0].classList.add('is-init');
                    return;
                }

                $img = new Image();
                $img.onload = function() {
                    $ele = document.createElement('div');
                    $ele.classList.add('swm-ui-image');
                    $ele.classList.add('is-active');

                    $ele.appendChild($img);

                    $imagewrap.appendChild($ele);

                    document.getElementsByTagName('body')[0].classList.add('is-init');
                };

                $img.src = src;
        }

        return {
            init: init
        };

    })();
})(jQuery, swm.frontend);

swm.frontend.intro.init();
